// extracted by mini-css-extract-plugin
module.exports = {"tablet":"768px","desktop":"1200px","grey100":"#F2F2F7","gridContainer":"CompactPackagesSection_gridContainer__z6BnU","swiper":"CompactPackagesSection_swiper__bFzMu"};